export default __webpack_public_path__ + "static/media/default.f0764c4b.png";